import { forEach } from './utils';
export function normalizeHeaderName(headers, normalizedName) {
    forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName &&
            typeof name === 'string' &&
            name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
}
//# sourceMappingURL=normalize-header-name.js.map